<template lang="pug">
  v-dialog(
    v-model="active"
    persistent
    width="800"
  )
    v-card(:loading="loading")
      v-card-title
        | Copy Ad Group

      v-card-text
        v-layout(row)
          v-flex
            v-data-table(
              :headers="headers"
              :items="items"
              item-key="campaign.id"
              v-model="itemSelecteds"
              show-select
            )

      v-card-actions.pa-3
        v-layout
          v-flex(xs6)
            v-btn(block color="green" :disabled="!isReady" @click="doSubmit") Start Copy
          v-flex(xs6)
            v-btn(block @click="active = false") Close
</template>

<script>
import { mapActions } from 'vuex'
import { copyAdGroups } from '@/helpers'

export default {
  props: {
    customerId: [String, Number],
    adGroupSelecteds: [Array]
  },
  data () {
    return {
      active: false,
      loading: false,
      items: [],
      itemSelecteds: [],
      headers: [
        { text: 'Campaign', value: 'campaign.name' }
      ]
    }
  },
  mounted () {
  },
  computed: {
    isReady () {
      return (this.itemSelecteds.length !== 0) && ((this.adGroupSelecteds || []).length !== 0)
    }
  },
  methods: {
    ...mapActions({
      'loadCampaigns': 'ads/loadCampaigns'
    }),
    show () {
      this.active = true
      this.loading = false
      this.doLoadCampaigns()
    },
    hide () {
      this.active = false
    },
    async doLoadCampaigns () {
      this.loading = true
      this.items = await this.loadCampaigns({ customerId: this.customerId })
      this.loading = false
    },
    async doCopyAdGroups () {
      return copyAdGroups(this.customerId, this.adGroupSelecteds, this.itemSelecteds)
    },
    async doSubmit () {
      this.loading = true
      await this.doCopyAdGroups()
      this.hide()
    }
  }
}
</script>

<style lang="stylus" scoped></style>
